<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-model="query['owner.id']" :options="owners" placeholder="placeholder.owner" @change="refresh"/>
        <vxe-input v-model="query['no']" placeholder="placeholder.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['customer.name']" placeholder="placeholder.supplierName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.no']" placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading" @cell-click="({row})=>showDetails(row)">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
        <vxe-column :title="refundable?'business.label.returnOrderNo':'business.label.receiptOrderNo'" field="order.no" width="120"/>
        <vxe-column :title="refundable?'business.label.returnType':'business.label.receivingType'" field="orderType.name" width="120"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:orderStatus}" field="order.orderStatus" title="business.label.orderStatus" width="100"/>
        <vxe-column field="owner.name" title="business.label.ownerName" width="200"/>
        <vxe-column field="customer.name" title="business.label.supplierName" width="400"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'

export default {
  name: 'ReceiptOrder',
  data() {
    return {
      loading: false,
      data: [],
      query: {
        'owner.id': undefined,
        'no': '',
        'customer.name': '',
        'item.no': '',
        'refundable': this.refundable
      },
      page: 1,
      size: 10,
      contentSize: 0
    }
  },
  activated() {
    this.refresh()
  },
  props: {
    refundable: {
      type: Boolean,
      default: false
    },
    orderStatus: {
      type: Array,
      default: []
    },
    owners: {
      type: Array,
      default: []
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      const args = {
        ...this.query,
        'owner.ids': this.query['owner.id'] ? [this.query['owner.id']] : [],
        'extract': true
      }
      this.loading = true
      findAll('receivingAsnListFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
          if (this.data.length > 0) {
            const row = this.data[0]
            this.$refs.table.setCurrentRow(row)
            this.showDetails(row)
          } else {
            this.clearDetails()
          }
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query['owner.id'] = undefined
      this.query['no'] = ''
      this.query['customer.name'] = ''
      this.query['item.no'] = ''
      this.fetch()
    },
    showDetails(row) {
      this.$emit('showDetails', row)
    },
    clearDetails() {
      this.$emit('clearDetails')
    }
  }
}
</script>